<!------------------------------- HTML ------------------------------------->

<Dialog id={dialogID} title="Gegenstand {titles[mode] ?? ''}" message={(editable && !hasChanges) ? "Keine Änderungen" : null}
        actions={[{id: 'cancel', label: "Abbrechen", func: () => document.getElementById(dialogID)?.close()},
                  {id: 'save', label: (mode === 'add') ? "Gegenstand erstellen" : "Änderungen speichern", symbol: 'check',
                   shown: editable, disabled: !hasChanges || !values.name, func: save_item}]}>
	<div class="dlg-body itemBody">
		<div class=datagrid>
			<label for=item-name data-help=itemname>Name</label>
			<input id=item-name data-help=itemname class=wide bind:value={values.name} placeholder={item.name ?? "Name des Gegenstands"} {disabled}>

			<label for=item-descript data-help=itemdescript>Beschr.</label>
			<textarea id=item-descript data-help=itemdescript class=wide rows=3 bind:value={values.descript} {disabled}></textarea>

			<label for=item-specials data-help=itemspecials>Besonderheit</label>
			<textarea id=item-specials data-help=itemspecials class=wide rows=3 bind:value={values.specials} {disabled}></textarea>

			{#if user.isMaster}
				<label for=item-perks data-help=itemperks>Boni in-App</label>
				<input id=item-perks data-help=itemperks class=wide value={perksToString(item.perks)} readonly title="Boni werden vom System gepflegt">
			{/if}

			<label for=item-type data-help=itemtype>Kategorie</label>
			<select id=item-type data-help=itemtype bind:value={values.type} {disabled}>
				{#each itemtypes as itype}
					<option value={itype.ID}>{itype.name}</option>
				{/each}
			</select>
			<span></span>

			{#if values.type === 'Weapon' || values.type === 'Armor'}
				<label for=item-base data-help=itembase>W-Art</label>
				<select id=item-base data-help=itembase bind:value={values.base} {disabled}>
					<option value="">–</option>
					{#each Object.entries(baseWeapons) as [group, weapons]}
						<optgroup label={group}>
							{#each weapons as weap}
								<option value={weap.ID}>{weap.name}</option>
							{/each}
						</optgroup>
					{/each}
				</select>
				<span></span>
			{/if}

			<label for=item-weight data-help=itemweight>Gewicht</label>
			<div class=unitBox>
				<input id=item-weight data-help=itemweight class=number type=number step=0.1 min=0 bind:value={values.weight} {disabled}>
				<span class=unit>kg</span>
			</div>
			<span></span>

			<label for=item-value data-help=itemvalue>Wert</label>
			<input id=item-value data-help=itemvalue class=number type=number min=0 bind:value={values.value} {disabled}>
			<span></span>
		</div>

		<div class=symbol>
			<div class=symbolBox>
				<img src={imgpath} alt={typeName}>
			</div>
			<span class=caption>{typeName}</span>
		</div>
	</div>
</Dialog>


<!------------------------------- SCRIPT ------------------------------------->

<script>
    import { user, view, send_data} from "../client.svelte.js";
    import {perksToString, protoWeapons} from "../core.js";
    import Dialog from "../elements/Dialog.svelte";
    import {onMount} from "svelte";

		const dialogID = 'item-edit-dialog'
    let { item, mode, storages } = $props()		// mode = add | chg | view

    const titles = {add: "hinzufügen", chg: "bearbeiten", view: "ansehen"}
    const attributes = ['name', 'descript', 'specials', 'weight', 'value', 'type', 'base']
		const itemtypes = [{ID: 'Weapon', name: "Waffe"}, {ID: 'Armor', name: "Rüstung"}, {ID: 'jewelry', name: "Schmuck"}, {ID: 'valuable', name: "Wertgegenstand"},
											 {ID: 'tool', name: "Werkzeug"}, {ID: 'accessoir', name: "Hilfsmittel"}, {ID: 'garment', name: "Kleidung"}]
		const baseWeapons = Object.groupBy(Object.values(protoWeapons), weap => weap.category)

		let editable = $derived(mode === 'add' || mode === 'chg')
		let disabled = $derived(!editable)
		let values = $state(Object.fromEntries(attributes.map(attr => [attr, item[attr] ?? ((attr === 'type') ? 'Weapon' : "")])))

		let changes = $derived(Object.fromEntries(
			Object.entries(values).filter(([attr,val]) => String(val ?? "") !== String(item[attr] ?? ""))))
		let hasChanges = $derived(Object.keys(changes).length > 0)
		let typeName = $derived(itemtypes.find(itype => itype.ID === values.type)?.name ?? "Gegenstand")
		let imgpath = $derived(item.imgpath || type_image(values.type))

    onMount( () => {
				const dialog = document.getElementById(dialogID)
				dialog.addEventListener('close', closing_dialog)		// close button, Escape and all actions end up here
				dialog.showModal()
	      console.log(`  – open item dialog in mode '${mode}' for `, $state.snapshot(item)) })


		function type_image(type) {
				return `/static/images/${(type ?? 'Accessoir').replace(/^./, c => c.toUpperCase())}.png`  }

    function closing_dialog() {
				view.close_dialog()  }

    function save_item() {
				if (!hasChanges)  return
				const itemChanges = $state.snapshot(changes)
				for (const attr of ['weight', 'value'])
						if (attr in itemChanges)  itemChanges[attr] = +itemChanges[attr] || 0
				if (mode === 'add' && !itemChanges.type)
						itemChanges.type = values.type
	      const requestData = Object.assign({ID: item.ID}, itemChanges, (mode === 'add') ? {source: view.adventure.ID} : {})
	      send_data(`/gearitem/${item.ID}`, requestData, (mode === 'add') ? 'POST' : 'PATCH')
	      console.log(`ITEM-EDIT: ${(mode === 'add') ? "create" : "change"} item ${item.ID} `, requestData)
    }

</script>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.itemBody
		display: flex
		flex-wrap: wrap
		gap: 16px
		width: min(780px, 90vw)
		box-sizing: border-box

	.datagrid
		flex: 1 1 380px
		display: grid
		grid-template-columns: 12ch minmax(0, 1fr) minmax(0, 1fr)
		gap: 10px 14px
		align-content: start
		padding: 14px
		background-color: colors.$grey-15
		border-radius: 6px

		label
			padding-top: 6px
			font-size: 13px
			color: colors.$grey-60

		input, select, textarea
			box-sizing: border-box
			width: 100%
			margin: 0
			padding: 5px 8px
			border: 1px solid colors.$grey-30
			border-radius: 4px
			background-color: colors.$grey-20
			color: colors.$white
			font: inherit

			&:focus-visible
				outline: 2px solid colors.$primary-100
				outline-offset: 1px

			&:disabled
				color: colors.$grey-60

		input[readonly]
			color: colors.$grey-60

		textarea
			min-height: 72px
			resize: vertical

		.wide
			grid-column: span 2

		.number
			text-align: right

	.unitBox
		display: flex
		align-items: center
		gap: 6px

	.unit
		font-size: 13px
		color: colors.$grey-60

	.symbol
		flex: 0 0 200px
		display: flex
		flex-direction: column
		gap: 6px

	.symbolBox
		display: grid
		place-items: center
		width: 200px
		height: 200px
		padding: 16px
		border: 1px solid colors.$grey-30
		border-radius: 6px
		background-color: colors.$grey-15
		img
			max-width: 100%
			max-height: 100%
			object-fit: contain

	.caption
		font-size: 12px
		color: colors.$grey-60

</style>
